module.exports = __webpack_public_path__ + "fonts/vivo-fonts.4752bcf1.ttf";